import React, { Component } from "react";
import { getBatch, postBatchList } from "../../actions/batchActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import api from "../../api";

class ViewBatch extends Component {
  constructor(props) {
    super();
    this.state = {
      id: "",
      cycleDate: "",
      batchDate: "",
      cycleNumber: "",
      totalAmount: "",
      receiptNumber: "",
      description: "",
      institution: "",
      uploaded: "",
      currency:"",
      selectedFile: "",
      receiptList:"",
      errors: {},
    };
    this.cancel = this.cancel.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.getReceipts=this.getReceipts.bind(this);
  }

  exportCSV() {
    this.dt.exportCSV();
  }

  componentDidMount() {
    const { batchId } = this.props.match.params;
    this.props.getBatch(batchId, this.props.history);
    this.getReceipts(batchId);
  }

  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    const {
      id,
      cycleDate,
      batchDate,
      cycleNumber,
      totalAmount,
      receiptNumber,
      description,
      institution,
      currency,
      uploaded,
      receiptList
     
    } = nextProps.batch;

    this.setState({
      id,
      cycleDate,
      batchDate,
      cycleNumber,
      totalAmount,
      receiptNumber,
      description,
      institution,
      uploaded,
      currency,
      receiptList
      
    });
  }

  cancel() {
    this.props.history.push("/batch-list");
  }

  selectFile = (event) => {
    const selectedFile = event.target.files[0];
    this.setState({ selectedFile });
  };

  uploadFile = (id) => {
    let currentFile = this.state.selectedFile;

    this.props.postBatchList(currentFile, id, this.props.history);
  };

getReceipts(batchId){
  const url=`/api/findbybatch/${batchId}`
    
     api.get(url).then((response) => {
        const data = response.data;
        this.setState({ receiptList: data });
     
      });
}

  render() {
    const { errors } = this.state;
    const header = (
      <div style={{ textAlign: "left" }}>
        <Button
          type="button"
          icon="pi pi-external-link"
          label="Download"
          onClick={this.exportCSV}
        ></Button>
      </div>
    );




    return (
      <div className="container mt-4">
        
        <div className="card m-auto  shadow-lg rounded p-3">
            <h5 className="display-4 text-center">
              Subscription Batch Details
            </h5>
            <p className="lead text-center">
              Batch Date :{this.state.batchDate}
            </p>
            <hr />
            {errors.message && (
              <div className="alert alert-danger text-center" role="alert">
                {errors.message}
              </div>
            )}

            <div className="row">
              <div className="form-group col">
                <label>Cycle Date: </label>{" "}
                <label>{this.state.cycleDate}</label>
              </div>

              <div className="form-group col">
                <label>Cycle Number: </label>{" "}
                <label>{this.state.cycleNumber}</label>
              </div>
              <div className="form-group col ">
                <label>Total Amount: </label>{" "}
                <label>{this.state.totalAmount}</label>
              </div>
            </div>
            
             
              <div className="row">
              <div className="form-group col">
                <label>Receipt Number: </label>{" "}
                <label>{this.state.receiptNumber}</label>
              </div>
              <div className="form-group col">
                <label>Currency: </label>{" "}
                <label>{this.state.currency}</label>
              </div>
              <div className="form-group col"></div>
            </div>
            <div className="row">
              <div className="form-group col">
                <label>Description: </label>{" "}
                <label>{this.state.description}</label>
              </div>
              <div className="form-group col"></div>
              <div className="form-group col">
                <label>Institution: </label>{" "}
                <label>{this.state.institution.institutionName}</label>
              </div>
            </div>
            <div className="form-group col">
              <button className="btn btn-secondary " onClick={this.cancel}>
                Cancel
              </button>
            </div>
            {!this.state.uploaded && (
              <div>
                {" "}
                <hr />
                <p className="lead text-center mb-3">
                  Choose subscription file to upload
                </p>
                <form>
                  <div>
                    <label className="btn btn-default">
                      <input type="file" onChange={this.selectFile} />
                    </label>
                    {this.state.selectedFile && (
                      <button
                        className="btn btn-success"
                        onClick={() => this.uploadFile(this.state.id)}
                      >
                        Upload
                      </button>
                    )}
                  </div>
                </form>

              </div>
            )}

            {this.state.uploaded && (
              <div>
            <hr />
            <p className="lead text-center">Membership list</p>
            <div className="card">
              <DataTable
                value={this.state.receiptList}
                header={header}
                ref={(el) => {
                  this.dt = el;
                }}
              >
                <Column field="member.firstname" header="Firstname"></Column>
                <Column field="member.surname" header="Surname"></Column>
                <Column field="member.nationalId" header="NationalId"></Column>
                <Column field="receiptDate" header="Receipt Date"></Column>
                <Column field="cycleNumber" header="Cycle Number"></Column>
                <Column field="receiptNumber" header="Reference Number"></Column>
                <Column field="amount" header="Amount"></Column>
              </DataTable>
            </div>
            </div>
            )}
          </div>
         
        </div>
      
    );
  }
}

ViewBatch.propTypes = {
  getBatch: PropTypes.func.isRequired,
  batch: PropTypes.object.isRequired,
  postBatchList: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  batch: state.batch.batch,

  errors: state.errors,
});

export default connect(mapStateToProps, {
  getBatch,
  postBatchList,
})(ViewBatch);
